exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-tips[data-v-606106ed]{color:#909399}.point-goods-form-container .form-block[data-v-606106ed]{padding:0 30px}.point-goods-form-container .form-block .avatar-uploader-icon[data-v-606106ed]{font-size:28px;color:#8c939d;width:100px;height:100px;line-height:100px;text-align:center;border:1px dashed #d9d9d9;border-radius:6px;border-color:#409EFF}.point-goods-form-container[data-v-606106ed] .el-upload-list__item{width:100px;height:100px}.point-goods-form-container[data-v-606106ed] .el-upload--picture-card{width:100px;height:100px;line-height:100px;border:none}\n", ""]);

// exports
